import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { DEFAULT_ROUTE_CONTROL_PARAMS, STICKY_BOTTOM_ROUTE_CONTROL_PARAMS, STICKY_LEFT_ROUTE_CONTROL_PARAMS } from '../../constants/routeControl';
import { ERouteControlViewType } from '../../types';
export var mapRouteReferencePoints = function mapRouteReferencePoints(referencePoints) {
  return referencePoints.reduce(function (acc, point) {
    if (!point) {
      return acc;
    }
    if (typeof point === 'string') {
      return [].concat(_toConsumableArray(acc), [point]);
    }
    if (Array.isArray(point)) {
      return [].concat(_toConsumableArray(acc), [point]);
    }
    if (point.getCoordinates) {
      var coordinates = point.getCoordinates();
      return coordinates ? [].concat(_toConsumableArray(acc), [coordinates]) : acc;
    }
    return acc;
  }, []);
};
export var getRouteControlOptions = function getRouteControlOptions(viewType) {
  switch (viewType) {
    case ERouteControlViewType.stickyLeft:
      return STICKY_LEFT_ROUTE_CONTROL_PARAMS;
    case ERouteControlViewType.stickyBottom:
      return STICKY_BOTTOM_ROUTE_CONTROL_PARAMS;
    default:
      return DEFAULT_ROUTE_CONTROL_PARAMS;
  }
};